// extracted by mini-css-extract-plugin
export default {"h1":"NotFound_h1__M0igR","h2":"NotFound_h2__1Tn2x","h3":"NotFound_h3__tdsEq"};